import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { CompanyRepository } from '../company-repository';
import type { CompanyService } from '../company-service';

@injectable()
export class CompanyServiceImpl implements CompanyService {
    constructor(
        @inject(CompanyRepository) private companyRepository: CompanyRepository
    ) {
    }

    getInfo(id: string, type: string) {
        return this.companyRepository.getInfo(id, type);
    }
}
